import { transport } from 'config/transport';

export function callApiSaveDuThuCongDoan(congDoanId, body, academicYear) {
    return transport.post(`/congdoan/${congDoanId}/duthu`, body, { params: { academicYear } });
}
